/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { SlOptions, SlOptionsVertical } from "react-icons/sl";
import Check from "../../assets/icons/Group.svg";
import Delete from "../../assets/icons/delete-bin-5-line.svg";
import Pending from "../../assets/icons/pending.svg";
import Arrows from "../../assets/icons/arrows.svg";
import Good from "../../assets/icons/good.svg";
import Bad from "../../assets/icons/bad.svg";
import Info from "../../assets/icons/information.svg";
import { useNavigate } from "react-router";
import { useToolsStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";
import { LoadMore, MainBtn, MainPaginate } from "../app/buttons";
import moment from "moment";
import { DeleteModal } from "../modals/donemodal";
import useErrorStore from "../../data/stores/errorStore";
import { toast } from "react-toastify";
import { SearchInput } from "../inputs/main";

const ToolsTable = ({ tab, tabs }) => {
	const [openPopup, setOpenPopup] = useState(null);
	const navigate = useNavigate();
	const popupRef = useRef(null),
		[modal, setModal] = useState<any>(null);
	const togglePopup = id => {
		if (openPopup === id) {
			setOpenPopup(null);
		} else {
			setOpenPopup(id);
		}
	};
	// useEffect(() => {
	//   function handleClickOutside(event) {
	//     // Close popup if click is outside the popup and the icon
	//     if (popupRef.current && !popupRef.current.contains(event.target)) {
	//       setOpenPopup(null);
	//     }
	//   }

	//   document.addEventListener("mousedown", handleClickOutside);
	//   return () => {
	//     document.removeEventListener("mousedown", handleClickOutside);
	//   };
	// }, [popupRef]);
	// const data = [
	//   {
	//     name: "integreted management information system",
	//     level: "utility",
	//     website: "lims.com",
	//     date: "11/09/22",
	//   },
	//   {
	//     name: "integreted management information system",
	//     level: "utility",
	//     website: "lims.com",
	//     date: "11/09/22",
	//   },
	//   {
	//     name: "integreted management information system",
	//     level: "utility",
	//     website: "lims.com",
	//     date: "11/09/22",
	//   },
	// ];
	const options = [
		{
			icon: Check,
			name: "view tool",
			color: "#505666",
			action: state =>
				navigate(`/tools/${state?.toolName || openPopup}`, { state }),
		},
		{
			icon: Check,
			name: "edit tool",
			color: "#505666",
			action: state => navigate(`/tools/add-tool`, { state }),
		},
		{
			icon: Delete,
			name: "delete tool",
			color: "#C5292A",
			action: sta => {
				setModal([sta]);
				setOpenPopup(null);
			},
		},
	];

	let [datum, setDatum] = useState<any>({ docs: [] }),
		{
			getLogger,
			mainSearch,
			isFound,
			data,
			recent,
			getDynamicLogger,
			deleteDynamicLogger,
		}: any = useToolsStore(),
		[loading, setLoading] = useState<string | boolean>(false);

	useEffect(() => {
		if (isFound) setDatum(mainSearch);
		else setDatum(tab === tabs?.[1] ? recent : data);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, isFound, mainSearch, tab, recent]);

	const handleLoadMore = async () => {
		setLoading("loadmore");
		await apiCall({
			type: "get",
			url: `/api/v1/tools?limit=${datum?.limit * datum?.nextPage}${
				tab !== tabs?.[0] ? `&streamline=week` : ""
			}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "recent") : getLogger(d),
		});
		setLoading(false);
	};

	let { returnErrors } = useErrorStore();
	const onSubmit = async () => {
		setLoading("delete");

		let { response, errArr, errMsg } = await apiCall({
			type: "delete",
			url: `/api/v1/tools`,
			data: {
				tools: modal?.map((it: any) => {
					return { toolsId: it?._id };
				}),
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			modal.forEach((element: any) => {
				deleteDynamicLogger(element, "data");
				deleteDynamicLogger(element, "recent");
			});
			setModal(null);
			apiCall({
				type: "get",
				url: `/api/v1/tools/stat`,
				getter: (d: any) => getDynamicLogger(d, "stat"),
			});
			return;
		}
		setLoading(false);
		setLoading(false);
	};

	const [itemOffset, setItemOffset] = useState(0);
	let [range] = useState(10);
	const endOffset = itemOffset + range;

	// if (!datum && !data) return <PageLoader />;
	if (!datum) return;

	const currentItems = datum?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(datum?.docs?.length / range);

	const handlePageClick = (event: any) => {
		const newOffset = (event.selected * range) % datum?.docs?.length;
		setItemOffset(newOffset);
	};

	return (
		<div>
			<TableTopSearch
				data={datum}
				setData={setDatum}
				handleDelete={() => {
					setModal(datum?.docs?.filter((iz:any) => iz?.isChecked));
				}}
			/>
			<table className="table-auto w-full">
				<thead className="grid grid-cols-5 items-center bg-[#F2FBFF] text-base font-medium text-da-blue-700 h-11 w-full px-8">
					<th className="col-span-2 text-left">Tool Name</th>
					<th className="col-span-1 text-left">Application Level</th>
					<th className="col-span-1 text-left">Website</th>
					<th className="col-span-1 text-left">Date added</th>
				</thead>
				<tbody>
					{currentItems?.map((it: any, i: number) => (
						<tr
							key={i}
							className="grid grid-cols-5 text-left px-8 text-base font-normal text-da-blue-800 items-center bg-transparent border-b border-b-[#eee]">
							<td className="col-span-2 h-14 flex gap-4 items-center">
								<input
									type="checkbox"
									name=""
									className="form-checkbox size-5 border border-[#ccc]"
									id={it?._id}
									onChange={e => {
										let dd = datum?.docs;
										let current = it;
										if (e?.target?.checked) {
											current = {
												...current,
												isChecked: true,
											};
										} else {
											current = {
												...current,
												isChecked: false,
											};
										}
										dd = dd?.map(ic => (ic?._id === it?._id ? current : ic));
										setDatum({ ...datum, docs: dd });
									}}
									checked={it?.isChecked}
								/>
								<span className="text-base font-normal first-letter:uppercase text-da-blue-800">
									{it?.toolName}
								</span>
							</td>
							<td className="first-letter:uppercase">
								{
									it?.toolSelection?.find(
										(it: { category: string; data?: string[] }) =>
											it?.category === "APPLICATION LEVEL"
									)?.data?.[0]
								}
							</td>
							<td className="">{it?.website}</td>
							<td className=" col-span-1 flex gap-8 items-center first-letter:uppercase relative">
								<span>{moment(it?.createdAt).format("DD-MM-YYYY")}</span>
								<SlOptions
									onClick={() => togglePopup(i)}
									className="cursor-pointer"
									color="#404040"
								/>
								{openPopup === i && (
									<div
										style={{
											boxShadow: "0px 10px 40px 0px #0000001A",
										}}
										className="absolute left-2 top-4 mt-2 p-5 bg-white shadow-lg rounded z-10">
										<div className="space-y-3">
											{options?.map((op, idx) => (
												<button
													key={idx}
													onClick={() => (op?.action ? op?.action(it) : {})}
													ref={popupRef}
													className={`h-9 w-32 ${
														idx === 0 && "bg-[#F4F4F4]"
													} bg-transparent flex gap-3 rounded-lg items-center`}>
													<img src={op?.icon} alt="" className="" />
													<span
														style={{
															color: op?.color,
														}}
														className="font-normal capitalize text-sm">
														{op?.name}
													</span>
												</button>
											))}
										</div>
									</div>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<div className="mt-10 flex justify-center w-44 items-center mx-auto">
				<LoadMore
					next={data?.hasNextPage}
					loading={loading === "loadmore"}
					handleLoadMore={handleLoadMore}
				/>
			</div>
			{pageCount > 1 && (
				<MainPaginate pageCount={pageCount} handlePageClick={handlePageClick} />
			)}
			{modal && (
				<DeleteModal
					page={"Tool"}
					close={onSubmit}
					handleClose={() => setModal("")}
					loading={loading === "delete"}
				/>
			)}
		</div>
	);
};

export default ToolsTable;

export const ProductTableRadio = ({ handleKpi, formIndex, product, index }) => {
	// console.log({ formIndex, index, product });

	return (
		<>
			<button className="flex justify-center items-center text-xlg gap-3">
				<span>Yes</span>
				<input
					type="radio"
					className="form-radio size-4 border border-[#AAB7C6]"
					onChange={e => handleKpi(e, formIndex, index)}
					title="yes"
					name={`status${product?.title || product?.name}${formIndex}${index}`}
					checked={product?.status === "yes"}
				/>
			</button>

			<button className="flex justify-center items-center text-lg gap-3">
				<span>No</span>
				<input
					type="radio"
					className="form-radio size-4 border border-[#AAB7C6]"
					onChange={e => handleKpi(e, formIndex, index)}
					title="no"
					name={`status${product?.title || product?.name}${formIndex}${index}`}
					checked={product?.status === "no"}
				/>
			</button>
		</>
	);
};

export const ProductTableShow = ({ product, prevData, title }) => {
	let [show, setShow] = useState("no");

	// console.log({ prevData, product, title });

	useEffect(() => {
		if (prevData) {
			let findOne = prevData?.find(it => it?.category === title);
			if (findOne) {
				let findTwo = findOne?.data?.find(it => it?.title === product?.title);
				if (findTwo) {
					setShow(findTwo?.status || "no");
				}
			}
		} else setShow(product?.status);
	}, [prevData, product]);

	return (
		<>
			{["good", "yes"]?.includes(show) ? (
				<button className="w-[25px] h-[25px] flex justify-center items-center text-xl font-bold bg-[#BAFED2]">
					<img src={Good} alt="" className="" />
				</button>
			) : (
				<button className="w-[25px] h-[25px] flex justify-center items-center text-xl font-bold bg-[#EF444433]">
					<img src={Bad} alt="" className="" />
				</button>
			)}
		</>
	);
};

export const ProductTable = ({
	products,
	start,
	selection,
	handleKpi,
	formIndex,
	prevData,
	title,
}) => {
	return (
		<div className="">
			<div
				style={{
					borderBottom: "1px solid #F1F5F9",
				}}
				className="flex px-1 justify-between items-center h-8 w-full bg-[#F8FAFC]">
				<div className="flex gap-1 items-center">
					<h6 className="text-base font-medium text-da-blue-600">
						Product Info
					</h6>
					<img src={Arrows} alt="" className="" />
				</div>
				<div className="flex gap-1 items-center">
					<h6 className="text-base font-medium text-da-blue-600">Status</h6>
					<img src={Arrows} alt="" className="" />
				</div>
			</div>

			<div>
				{products?.map((product: any, index: number) => (
					<div
						style={{
							borderBottom: "1px solid #F1F5F9",
						}}
						key={index}
						className={`${
							index % 2 === 0 ? "bg-white" : "bg-[#F8FAFC]"
						} flex justify-between px-1 h-10 py-3 items-center w-full`}>
						<span className=" text-da-blue-600 text-xs truncate w-5/6">
							{product?.title || product?.name}
						</span>
						<div className="flex justify-end gap-3">
							{!start && (
								<button className="w-[25px] h-[25px] flex justify-center items-center text-xl font-bold bg-[#D2D7D4]">
									<img src={Pending} alt="" className="" />
								</button>
							)}
							{start && selection && (
								<ProductTableRadio
									product={product}
									formIndex={formIndex}
									index={index}
									handleKpi={handleKpi}
								/>
							)}
							{start && !selection && (
								<ProductTableShow
									prevData={prevData}
									product={product}
									title={title}
								/>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export const WhiteBox = ({ children, className = "", shadow = false }) => {
	return (
		<div
			style={{
				boxShadow: shadow ? "4px 4px 100px 0px #00000014" : "",
			}}
			className={`w-full min-h-72 bg-white rounded-lg p-5 ${className}`}>
			{children}
		</div>
	);
};

export const ToolsKPIsData = ({
	start,
	data,
	title,
	selection,
	handleKpi,
	formIndex,
	shadow = false,
	prevData,
	setInfo,
}: any) => {
	return (
		<WhiteBox className="h-full" shadow={shadow}>
			<div className="flex justify-between items-center">
				<h5 className="text-base text-da-blue-600 font-medium capitalize">
					{title ? title?.toLowerCase() : ""}
				</h5>
				<img
					src={Info}
					alt=""
					onClick={() => {
						if (setInfo) {
							setInfo();
						}
					}}
					className=" cursor-pointer"
				/>
			</div>
			<div className="mt-2">
				<ProductTable
					start={start}
					products={data}
					selection={selection}
					handleKpi={handleKpi}
					formIndex={formIndex}
					prevData={prevData}
					title={title}
				/>
			</div>
		</WhiteBox>
	);
};

export const TableTopSearch = ({
	data,
	setData,
	handleDelete,
}: {
	data?: any;
	setData?: any;
	handleDelete?: () => any;
}) => {
	return (
		<div className="h-24 flex justify-between items-center w-full mb-4">
			<div className="flex gap-3 items-center">
				<input
					type="checkbox"
					className="form-checkbox size-5 border border-[#ccc]"
					id="check-all-searchbox"
					onChange={e => {
						let dd = data?.docs;
						dd = dd?.map((ic: any) => {
							let dc = ic;
							return { ...dc, isChecked: e?.target?.checked };
						});
						setData({ ...data, docs: dd });
					}}
					checked={
						data?.docs?.length > 0 &&
						data?.docs?.every((it: any) => it?.isChecked)
					}
				/>
				<SlOptionsVertical color="#757575" />
				<SearchInput placeholder="Search" icon="jam:search" />
			</div>
			<div className="flex gap-4 items-center">
				<h4 className="text-base font-normal text-da-blue-600">Sort By</h4>
				<select
					name=""
					className="form-select text-base font-normal text-[#130019] h-10 w-40 border-[0.5px] border-[#ccc] rounded-lg px-3"
					id="">
					<option value="" selected>
						Most Recent
					</option>
				</select>
				{data?.docs?.some?.((ic: any) => ic?.isChecked) && (
					<MainBtn
						onClick={handleDelete ? handleDelete : () => console.log("object")}
						text={"Delete Selection"}
						bg={"#3787FF"}
						color={"white"}
						className="w-40"
					/>
				)}
			</div>
		</div>
	);
};